import React from 'react';
import { useParams } from 'react-router-dom';
import { ProFormText, ProFormDatePicker } from '@ant-design/pro-form';
import PropTypes from 'prop-types';
import ProForm from '../../../layout/ProForm';
import SelectReportType from '../../../input/SelectReportType';
import { PLACEHOLDER } from 'constants/form';

const ReportSubmissionScheduleForm = ({ onFinish, initialValues }) => {
  const { projectId } = useParams();

  return (
    <ProForm
      initialValues={initialValues}
      previousLevel={`/projects/${projectId}/report-submissions`}
      onFinish={onFinish}
    >
      <SelectReportType
        rules={[
          {
            required: true,
            message: 'Please select report type!',
          },
        ]}
      />
      <ProFormDatePicker
        label="Scheduled Submission Date (YYYY-MM-DD)"
        name="scheduledSubmissionDate"
        placeholder={PLACEHOLDER.PLEASE_SELECT}
        width="xl"
        rules={[
          {
            required: true,
            message: 'Please select scheduled submission date!',
          },
        ]}
      />
      <ProFormText
        width="xl"
        name="reportingPeriod"
        label="Reporting Period"
        placeholder={PLACEHOLDER.PLEASE_ENTER}
        rules={[{ required: true, message: 'Please enter reporting period!' }]}
      />
    </ProForm>
  );
};

ReportSubmissionScheduleForm.defaultProps = {
  initialValues: {},
};

ReportSubmissionScheduleForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};

export default ReportSubmissionScheduleForm;
